import { InjectedProperty } from "../../../Global/Base/DIContainer";
import { GlobalContext } from "../../../Global/Base/GlobalContext";
/**Rozhraní aplikační cache*/
export interface IAppCache {
    /**
    * Nastaví hodnotu pro property v cache.
    * @param property Unikátní název nebo ID property.
    * @param value Hodnota property.
    */
    setValue(property: string | number, value: any): void;

    /**
     * Získá hodnotu property v cache
     * @param property Unikátní název nebo ID property.
     */
    getValue<T>(property: string | number): T | undefined;
}

export class IAppCache {
    private static _properties = ["setValue", "getValue"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value));
    }
}

export class ApplicationCache {
    public static get instance(): IAppCache {
        return {} as any;
    }
}

InjectedProperty.bindProperty(ApplicationCache, "instance", IAppCache);
GlobalContext.register("ApplicationCache", ApplicationCache);
